import {
  TextureLoader,
  RepeatWrapping,
  MeshStandardMaterial
} from "three";


const loader = new TextureLoader();
const platAO = loader.load('/assets/platMaterial/plat_ao.jpg');
const platDiffu = loader.load('/assets/platMaterial/plat_diffu.jpg');
const platNorm=loader.load('/assets/platMaterial/plat_norm.jpg');
const platRough=loader.load('/assets/platMaterial/plat_rough.jpg');

// 纹理平铺和清晰度
platAO.wrapS = platAO.wrapT = RepeatWrapping;
platDiffu.wrapS = platDiffu.wrapT = RepeatWrapping;
platNorm.wrapS = platNorm.wrapT = RepeatWrapping;

export const platMaterial = new MeshStandardMaterial({
  map: platDiffu,
  normalMap: platNorm,
  aoMap: platAO,
  roughnessMap: platRough
});